<template>
	<div>
		<el-card class="shoplist">
			<div v-for="(tab,index) in tabs" :key="index">
				<el-row>
					<el-col :span="20"><handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton></el-col>
					<el-col :span="4">
						<el-input placeholder="搜索" v-model="searchkey" size="small" @keyup.enter.native="refreshgrid(true)"></el-input>
						</el-input>
					</el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
				<el-col :span="24">
					<tableui style="width:100%;" v-loading="loading" editcell="0" ref="shoplisttable" :tableData="shoplist" :columns="tab.columns" @gridhandle="gridhandle" :gridheight="gridheight"></tableui>
				</el-col>
				<el-col>共{{ count }}条数据</el-col>
			</el-row>
			</div>
		</el-card>
		<group ref="group"></group>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import group from '@/components/user/group.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton,
		group
	},
	data() {
		return {
			tabs:[],
			searchkey:'',
			shoplist: [],
			count: 0,
			pagecount: 1,
			gridheight: (window.innerHeight * 74) / 100 + 'px',
			loading: false,
			shopname:'',
			divclass:'shoplist',
			mode:'门店管理',
			activeTabIndex:0,
			pageindex:0,
			pagesize:200,
			activeName:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/shoplist.scss');
			this.getTabs();
		});
		var that=this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});	
	},
	methods: {
		//获取选项卡
		getTabs() {
			this.$apipost.get.GetTabs({ parentid: 199 }).then(res => {
				this.tabs = res.tabs;
				this.activeName = res.tabs[0].type;
				this.GetTabData();
			});
		},
		//获取表头方法
		GetTabData() {
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.shoplist = [];
				//刷新
				this.pageindex = 0;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if(isload){
				var paraminfo={
					search: this.searchkey,
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					tab: this.activeName,
					l_mode: this.mode,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					userid: localStorage.getItem('userid')
				}
				this.$apipost.get.Getshop({ paraminfo: paraminfo }).then(res => {
					that.loading = false;
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.shoplist = that.shoplist.concat(res.data);
						} else {
							that.shoplist = res.data;
						}
					}
					that.count = res.count;
					that.tabs[that.activeTabIndex].pagecount = res.pagecount;
				});
			}
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'add') {
				if (this.$refs.group != undefined) {
					this.$refs.group.init();
				}
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			if (e.event == 'del') {
				this.delshop(this.shoplist[e.index].s_name);
			}
			if(e.event=='edit'){
				if (this.$refs.group != undefined) {
					this.$refs.group.init({groupkey:this.shoplist[e.index].id});
				}
			}
			if (e.event == 'setuser') {
				Utils.$emit('go', { l_url: '/group/setuser',l_id:e.l_id, l_name: '设置人员('+this.shoplist[e.index].s_name+')', urlparam: { shopname: this.shoplist[e.index].s_name} });
			}
		},
		//删除门店
		delshop(shopname) {
			var that = this;
			this.$confirm('确定要删除【'+shopname+'】吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal:false
			}).then(() => {
					this.$apipost.post.DelGroup({ s_name: shopname }).then(res => {
						if (res.state == '1') {
							this.$tool.message('删除成功', 1);
							that.refreshgrid(true);
						} else {
							this.$tool.message(res.message, 0);
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>
